module.exports = __webpack_public_path__ + "media/application/images/icons/email-a7b22221ae0e466b8328526e2857f41a.svg";